



























































import Vue from 'vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { ISplideOptions } from '@/common/interfaces/external.interface';
import { IIcons } from '@/common/interfaces/index.interface';
import TIcons from '@/types/TIcons';
import { IBlogPostsData } from '@/common/interfaces/blog.interface';
import config from '../../../../config';
import ImageWithErrorMessage from '@/components/newsingleproductpage/subcomponents/imagewitherrormessage/ImageWithErrorMessage.vue';

interface IBlogSectionComponent {
  fallbackImage: string;
  icons: IIcons;
  splideOptions: ISplideOptions;
}

export default Vue.extend({
  name: `BlogSection`,
  components: { ImageWithErrorMessage, Splide, SplideSlide },
  data(): IBlogSectionComponent {
    return {
      fallbackImage: config.images.fallbackImage,
      icons: TIcons,
      splideOptions: {
        arrows: true,
        pagination: false,
        type: `loop`,
      },
    };
  },
  props: {
    blogPosts: {
      required: true,
      type: Array as () => IBlogPostsData[],
    },
  },
});
